import type { AutocompleteOption } from '../../types';

export const popularDestinations: AutocompleteOption[] = [
    {
        id: 'popular-spania',
        text: 'Spania',
        bounds: { southwest_lat: 33.499548, southwest_lng: -9.716923, northeast_lat: 46.044901, northeast_lng: 3.403853 },
        country: 'Spania',
        isCountry: true,
    },
    {
        id: 'popular-kanariaoyene',
        text: 'Kanariøyene, Spania',
        bounds: { southwest_lat: 27.425414, southwest_lng: -18.391113, northeast_lat: 29.463514, northeast_lng: -13.31543 },
        country: 'Spania',
        isCountry: false,
    },
    {
        id: 'popular-hellas',
        text: 'Hellas',
        bounds: { southwest_lat: 33.394675, southwest_lng: 19.829526, northeast_lat: 41.942383, northeast_lng: 28.486011 },
        country: 'Hellas',
        isCountry: true,
    },
    {
        id: 'popular-kreta',
        text: 'Kreta',
        bounds: { southwest_lat: 34.800883, southwest_lng: 23.471621, northeast_lat: 35.695695, northeast_lng: 26.352519 },
        country: 'Hellas',
        isCountry: false,
    },
    {
        id: 'popular-italia',
        text: 'Italia',
        bounds: { southwest_lat: 35.4897, southwest_lng: 6.62672, northeast_lat: 47.092, northeast_lng: 18.7976 },
        country: 'Italia',
        isCountry: true,
    },
    {
        id: 'popular-kroatia',
        text: 'Kroatia',
        bounds: { southwest_lat: 42.338509, southwest_lng: 13.3649, northeast_lat: 46.55502, northeast_lng: 19.447377 },
        country: 'Kroatia',
        isCountry: true,
    },
    {
        id: 'popular-tyrkia',
        text: 'Tyrkia',
        bounds: { southwest_lat: 35.805916, southwest_lng: 25.440814, northeast_lat: 42.3667, northeast_lng: 44.817845 },
        country: 'Tyrkia',
        isCountry: true,
    },
    {
        id: 'popular-portugal',
        text: 'Portugal',
        bounds: { southwest_lat: 36.531357, southwest_lng: -11.307449, northeast_lat: 42.43076, northeast_lng: -5.186391 },
        country: 'Portugal',
        isCountry: true,
    },
];

export const popularDestinationsTitle = 'Populære reisemål 🏖';

export const popularDestinationsTip = { title: 'Tips!', body: 'Du kan skrive inn en by, et land eller et område du vil reise til.' };
